import { Avatar, Box, Button, Grid2, MenuItem, Modal, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TokenError from "../tokenError";
import config from '../../config/config.js';
import { makeGetRequestToUrl } from '../commonFunc.jsx';
import { makePostRequestToUrl } from '../commonFunc.jsx';
import { useNavigate } from "react-router-dom";
import { Label } from "flowbite-react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
var constant = require('../../constant.js');



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px'
};

const ChangeDestination = () => {

    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [changeDestinationData, setChangeDestinationData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [name, setName] = useState('');
    const [selectedEngagementID, setSelectedEngagementId] = useState('');
    const [destinationLogs, setDestinationLogs] = useState([]);
    const [selectedRow, setSelectedRow] = useState([])

    const [startDateFilter, setStartDateFilter] = useState(dayjs());
    const [endDateFilter, setEndDateFilter] = useState(dayjs());
    const [statusFilter, setStatusFilter] = useState('');
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';

    const handleCityChange = (e) => {
        const city = cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const fetchChangeDestinationData = async () => {
        try {
            const url = serverUrl + '/customer/fetch_list_change_destination';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD')
                // timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if (response.flag == 200) {
                setChangeDestinationData(response.data);
                setAllData(response.data);
            }
            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchDestinationLogs = async (engagementId) => {
        try {
            const url =
                serverUrl + '/customer/fetch_view_change_destination';

            const body = {
                token,
                engagement_id: engagementId,
            };

            const response = await makeGetRequestToUrl(url, body);

            if (response.flag === 200) {
                setDestinationLogs(response.data || []);
                setOpenAddModal(true);
            }

            if (response.flag === 102) {
                localStorage.removeItem('token');

                setErrorMessage(
                    'Your session has expired. Please log in again.'
                );

                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const handleOpenViewLogs = (row) => {
        setSelectedRow(row)
        setSelectedEngagementId(row.engagement_id);
        fetchDestinationLogs(row.engagement_id);
    };

    // const setEnabled = async(id, val) => {
    //     // console.log('id= ', id, 'and val= ', val);
    //     try {
    //         const token = localStorage.getItem('token');
    //         const body = {
    //             token: token,
    //             // name: name,
    //             is_active: val,
    //             city_id: cityFilter,
    //             id: id
    //         };

    //         const response = await fetch(operationsUrl + '/shuttle/add_update_cancellation_reason', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify(body)
    //         });
    //         const data = await response.json();

    //         if (data.flag==200) {
    //             handleClose();
    //             fetchChangeDestinationData();
    //             setMessage(data.message);
    //             showSnackbar(true);
    //         } 
    //         else {
    //             setError(data.message || 'Login failed. Please try again.');
    //         }
    //     } catch (error) {
    //         setError('An error occurred. Please try again later.');
    //     }
    // }

    useEffect(() => {
        fetchChangeDestinationData();
    }, [cityFilter, startDateFilter, endDateFilter]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        showSnackbar(false);
    };

    const handleOpenAddModal = () => {
    }

    const handleClose = () => {
        setOpenAddModal(false);
    }

    useEffect(() => {
        const filteredData = statusFilter === ''
        ? allData
        : allData.filter((row) => row.status === statusFilter);
        setChangeDestinationData(filteredData);
    }, [statusFilter]);

    return (
        <div>
            {tokenExpired && (<TokenError />)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Change Destination</Typography>

            <Grid2 container spacing={1.5} xs={12} md={8} alignItems="flex-end">
                <Select
                    value={cityFilter}
                    onChange={(e) => setCityFilter(e.target.value)}
                    displayEmpty
                    style={{
                        width: '180px',
                        height: '44px',
                        borderRadius: '8px',
                        backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                    }}
                >
                    <MenuItem value="">Select City</MenuItem>
                    {cities.map((city) => (
                        <MenuItem key={city.city_id} value={city.city_id}>
                            {city.city_name}
                        </MenuItem>
                    ))}
                </Select>

                <Grid2 item>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '160px',
                                '& .MuiInputBase-root': {
                                    minHeight: '44px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px',
                                    minWidth:'160px'
                                }
                            }}
                            value={startDateFilter}
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            onChange={(newValue) => {
                                if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                    setEndDateFilter(null);
                                }
                                setStartDateFilter(newValue);
                            }}
                            maxDate={endDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '160px',
                                '& .MuiInputBase-root': {
                                    minHeight: '44px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px',
                                    minWidth:'160px'
                                }
                            }}
                            value={endDateFilter}
                            onChange={(newValue) => {
                                setEndDateFilter(newValue)
                            }}
                            minDate={startDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Label>Status:</Label><br/>
                    <Select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        displayEmpty
                        style={{
                            width: '180px',
                            height: '44px',
                            borderRadius: '8px',
                            marginTop: '4px',
                            backgroundColor: statusFilter !== '' ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">All Status</MenuItem>
                        {Object.entries(constant.taxiEngagementStatus).map(([key, value]) => (
                            <MenuItem key={value} value={value}>
                                <Typography sx={{textTransform:'lowercase', '&::first-letter': { textTransform: 'uppercase' },}}
                                // sx={{ color: constant.taxiEngagementStatusSolidColors[key] }}
                                >
                                    {key.replaceAll('_', ' ')}
                                </Typography>
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
            </Grid2>

            <Modal open={openAddModal} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <hr />
                    <Grid2 id="modal-modal-description" sx={{ mt: 6 }}>
                        <Grid2 item container size={12} sx={{ marginTop: '6%' }}>
                            <Grid2 item size={2.5}>
                                <Typography>Name</Typography>
                            </Grid2>
                            <Grid2 item size={1}><Typography sx={{ marginLeft: '4%' }}>:</Typography></Grid2>
                            <Grid2 item size={7.5}>
                                <TextField size="small" type="text" value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    sx={{ height: '30px', marginLeft: '4%' }} fullWidth
                                />
                            </Grid2>
                        </Grid2>

                    </Grid2>
                </Box>
            </Modal>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Engagement ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>User Id</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Customer Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '20%' }}>Pickup Address</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '20%' }}>Drop Address</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '20%' }}>Pickup Time</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '20%' }}>Drop Time</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {changeDestinationData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            changeDestinationData.map((row) => {

                                return (
                                    <TableRow key={row.id}>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.engagement_id}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_id}</Typography></TableCell>
                                        <TableCell>
                                            <Grid2 container sx={{ width: 'auto', minWidth: '180px' }}>
                                                <Grid2>
                                                    <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt={row.user_name} src={row.user_image} />
                                                </Grid2>
                                                <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                                                    <Grid2>
                                                        <Typography>{row.user_name}</Typography>
                                                    </Grid2>
                                                    <Grid2>
                                                        <Typography sx={{ color: '#83888E', fontSize: '12px' }}>
                                                            {row.phone_number}
                                                        </Typography>
                                                    </Grid2>
                                                </Grid2>
                                            </Grid2>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography 
                                                sx={{
                                                    color: constant.taxiEngagementStatusSolidColors[
                                                    constant.taxiEngagementStatusReverse[row?.status]
                                                    ]
                                                }}
                                            >{(constant.taxiEngagementStatusReverse[row?.status])?.replaceAll('_', ' ')}</Typography>
                                        </TableCell>
                                        <TableCell align="center" sx={{minWidth:'80px'}}>{row?.total_fare}</TableCell>
                                        <TableCell align="center" sx={{minWidth:'120px'}}>{row?.pickup_address}</TableCell>
                                        <TableCell align="center" sx={{minWidth:'120px'}}>{row?.drop_address}</TableCell>

                                        <TableCell align="center" sx={{minWidth:'120px'}}>
                                        {row.pickup_time ? 
                                            (() => {
                                                const pickupTime = new Date(row.pickup_time);
                                                pickupTime.setMinutes(pickupTime.getMinutes() + utcOffset);
                                                return pickupTime.toLocaleString('en-GB', {
                                                day: '2-digit', 
                                                month: 'short', 
                                                year: 'numeric', 
                                                hour: '2-digit', 
                                                minute: '2-digit', 
                                                hour12: timeZoneFormat == '12' ? true : false,
                                                timeZone: 'UTC'
                                                }).replace(',', ' |');
                                            })() 
                                            : '--'
                                        }
                                        </TableCell>
                                        <TableCell align="center" sx={{minWidth:'120px'}}>
                                        {row.drop_time ? 
                                            (() => {
                                                const pickupTime = new Date(row.drop_time);
                                                pickupTime.setMinutes(pickupTime.getMinutes() + utcOffset);
                                                return pickupTime.toLocaleString('en-GB', {
                                                day: '2-digit', 
                                                month: 'short', 
                                                year: 'numeric', 
                                                hour: '2-digit', 
                                                minute: '2-digit', 
                                                hour12: timeZoneFormat == '12' ? true : false,
                                                timeZone: 'UTC'
                                                }).replace(',', ' |');
                                            })() 
                                            : '--'
                                        }
                                        </TableCell>

                                        {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px', color: row.is_active === 1 ? '#0DBA78' : '#D14545', fontWeight:'500'  }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell> */}

                                        <TableCell align="center">
                                            <Button
                                                variant="contained"
                                                onClick={() => handleOpenViewLogs(row)}
                                                sx={{
                                                    backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                    borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "140px",
                                                    '&:hover': { backgroundColor: '#0DBA78', color: 'white' },
                                                    '&:active': { backgroundColor: '#0DBA78', color: 'white' },
                                                    whiteSpace: 'nowrap'
                                                }}>

                                                <Typography sx={{ marginRight: '6%' }}>View Details</Typography>

                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <Modal
                open={openAddModal}
                onClose={handleClose}
                aria-labelledby="change-destination-logs-modal"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '92%', sm: '85%', md: 900 },
                        maxHeight: '90vh',
                        bgcolor: '#FFFFFF',
                        borderRadius: '16px',
                        boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.15)',
                        overflow: 'hidden',
                        outline: 'none',
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            px: 3,
                            py: 2.5,
                            borderBottom: '1px solid #E8EAED',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box>
                            <Typography
                                sx={{
                                    fontSize: '20px',
                                    fontWeight: 600,
                                    color: '#202124',
                                }}
                            >
                                Destination Change History of {selectedRow.user_name}
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: '13px',
                                    color: '#83888E',
                                    mt: 0.5,
                                }}
                            >
                                Engagement Id: {selectedEngagementID}
                            </Typography>
                        </Box>

                        <Button
                            onClick={handleClose}
                            sx={{
                                minWidth: '38px',
                                width: '38px',
                                height: '38px',
                                borderRadius: '50%',
                                color: '#5F6368',
                                fontSize: '20px',
                                '&:hover': {
                                    backgroundColor: '#F1F3F4',
                                },
                            }}
                        >
                            ✕
                        </Button>
                    </Box>

                    {/* Summary */}
                    <Box
                        sx={{
                            mx: 3,
                            mt: 2.5,
                            p: 2,
                            backgroundColor: '#F6F9FF',
                            border: '1px solid #DCE7FF',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '14px',
                                color: '#83888E',
                            }}
                        >
                            Total Destination Changes:
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: '18px',
                                fontWeight: 600,
                                color: '#0065FF',
                            }}
                        >
                            {destinationLogs.length}
                        </Typography>
                    </Box>

                    {/* Timeline */}
                    <Box
                        sx={{
                            px: 3,
                            py: 3,
                            maxHeight: '58vh',
                            overflowY: 'auto',

                            '&::-webkit-scrollbar': {
                                width: '5px',
                            },

                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#D6D9DD',
                                borderRadius: '10px',
                            },
                        }}
                    >
                        {destinationLogs.length === 0 ? (
                            <Box
                                sx={{
                                    py: 6,
                                    textAlign: 'center',
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: '#83888E',
                                        fontSize: '14px',
                                    }}
                                >
                                    No destination change history found
                                </Typography>
                            </Box>
                        ) : (
                            destinationLogs.map((log, index) => (
                                <Box
                                    key={`${log.engagement_id}-${log.created_at}`}
                                    sx={{
                                        display: 'flex',
                                        position: 'relative',
                                    }}
                                >
                                    {/* Timeline Indicator */}
                                    <Box
                                        sx={{
                                            width: '35px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: '12px',
                                                height: '12px',
                                                borderRadius: '50%',
                                                backgroundColor: '#0065FF',
                                                border: '3px solid #DCE8FF',
                                                zIndex: 2,
                                            }}
                                        />

                                        {index !== destinationLogs.length - 1 && (
                                            <Box
                                                sx={{
                                                    width: '2px',
                                                    flex: 1,
                                                    minHeight: '170px',
                                                    backgroundColor: '#E4E7EB',
                                                }}
                                            />
                                        )}
                                    </Box>

                                    {/* Log Card */}
                                    <Box
                                        sx={{
                                            flex: 1,
                                            mb:
                                                index !== destinationLogs.length - 1
                                                    ? 2.5
                                                    : 0,
                                            ml: 1,
                                            p: 2.5,
                                            border: '1px solid #E8EAED',
                                            borderRadius: '12px',
                                            backgroundColor: '#FFFFFF',
                                            transition: '0.2s ease',

                                            '&:hover': {
                                                borderColor: '#B8CCF5',
                                                boxShadow:
                                                    '0px 4px 14px rgba(0, 101, 255, 0.08)',
                                            },
                                        }}
                                    >
                                        {/* Card Header */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                mb: 2,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    color: '#202124',
                                                }}
                                            >
                                                Destination Change #{index + 1}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: '12px',
                                                    color: '#83888E',
                                                }}
                                            >
                                                {new Date(
                                                    log.created_at
                                                ).toLocaleString('en-IN', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                })}
                                            </Typography>
                                        </Box>

                                        {/* Destination Details */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                gap: 2,
                                                alignItems: 'stretch',
                                            }}
                                        >
                                            {/* Previous Address */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    p: 2, display:'flex', flexDirection:'column',
                                                    backgroundColor: '#FFF7F7',
                                                    borderRadius: '8px',
                                                    border: '1px solid #FFE1E1',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: '11px',
                                                        fontWeight: 600,
                                                        color: '#D14545',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px',
                                                        mb: 1,
                                                    }}
                                                >
                                                    Previous Destination
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: '13px',
                                                        fontWeight: 500,
                                                        color: '#34383C',
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    {log.prev_address || ''}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: '11px',
                                                        color: '#83888E',
                                                        mt: 1.5, mb:1
                                                    }}
                                                >
                                                    {log.prev_latitude},
                                                    {' '}
                                                    {log.prev_longitude}
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                                        p: 0.5, background: '#fff', mt: 'auto'
                                                    }}
                                                >
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#83888E'}}>
                                                        Fare
                                                    </Typography>

                                                    <Typography sx={{fontSize: '13px', fontWeight: 600, color: '#C62828'}}>
                                                        {Number(log.prev_fare || 0).toFixed(2)}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Arrow */}
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#EEF4FF',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: '#0065FF',
                                                        fontSize: '18px',
                                                    }}
                                                >
                                                    →
                                                </Box>
                                            </Box>

                                            {/* Changed At */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    p: 2,
                                                    backgroundColor: '#F7F0E9',
                                                    borderRadius: '8px',
                                                    border: '1px solid #D3B683',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: '11px',
                                                        fontWeight: 600,
                                                        color: '#A35B23',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px',
                                                        mb: 1,
                                                    }}
                                                >
                                                    Changed At
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: '13px',
                                                        fontWeight: 500,
                                                        color: '#34383C',
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    {log.changed_at_address || ''}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: '11px',
                                                        color: '#83888E',
                                                        mt: 1.5,
                                                    }}
                                                >
                                                    {log.changed_at_latitude},
                                                    {' '}
                                                    {log.changed_at_longitude}
                                                </Typography>
                                            </Box>

                                            {/* Arrow */}
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#EEF4FF',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: '#0065FF',
                                                        fontSize: '18px',
                                                    }}
                                                >
                                                    →
                                                </Box>
                                            </Box>

                                            {/* New Address */}
                                            <Box
                                                sx={{
                                                    flex: 1, display:'flex',flexDirection:'column',
                                                    p: 2,
                                                    backgroundColor: '#F3FCF8',
                                                    borderRadius: '8px',
                                                    border: '1px solid #D3F3E5',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: '11px',
                                                        fontWeight: 600,
                                                        color: '#0DBA78',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px',
                                                        mb: 1,
                                                    }}
                                                >
                                                    New Destination
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: '13px',
                                                        fontWeight: 500,
                                                        color: '#34383C',
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    {log.new_address || ''}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: '11px',
                                                        color: '#83888E',
                                                        mt: 1.5, mb:1
                                                    }}
                                                >
                                                    {log.new_latitude},
                                                    {' '}
                                                    {log.new_longitude}
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        mt: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                                        p: 0.5, background: '#fff',
                                                    }}
                                                >
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#83888E'}}>
                                                        Fare
                                                    </Typography>

                                                    <Typography sx={{fontSize: '13px', fontWeight: 600, color: '#15803D'}}>
                                                        {Number(log.new_fare || 0).toFixed(2)}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            ))
                        )}
                    </Box>

                </Box>
            </Modal>


            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default ChangeDestination;